import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

export default function List(theme: Theme) {
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          /**
           * The cream `action.selected` tint marks a selected table/list row, where
           * a checked checkbox is a second, redundant cue. A ListItemButton (org
           * switcher, settings side lists, pickers, drawers) has no such second
           * cue — it IS the selection state — so the faint cream disappears against
           * a white background. Use the neutral fill plus medium weight instead,
           * and keep hover visibly distinct from it. Mirrors MuiMenuItem's override
           * in Menu.ts for the same reason.
           */
          '&.Mui-selected': {
            backgroundColor: theme.palette.background.neutral,
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: 'inherit',
          minWidth: 'auto',
          marginRight: theme.spacing(2),
        },
      },
    },
    MuiListItemAvatar: {
      styleOverrides: {
        root: {
          minWidth: 'auto',
          marginRight: theme.spacing(2),
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          marginTop: 0,
          marginBottom: 0,
        },
        multiline: {
          marginTop: 0,
          marginBottom: 0,
        },
      },
    },
  }
}
